import noop from 'utils/noop';
import { Radio } from 'ui/radio';
import { BooleanPickerContainer, BooleanPicker } from './CriteriaPropertyField.styled';

// type Props = {
//   /** If the boolean field has an error. */
//   error: boolean,
//   /** Array comtaining the group index, query index and criteria property index. */
//   fieldIdentifier: [],
//   /** Callback function when boolean value is changed. */
//   onChange: () => {},
//   /** The value of the boolean field. */
//   value: string,
//   disabled?: boolean,
// };

const Items = [
  {
    label: 'True',
    value: 'true',
  },
  {
    label: 'False',
    value: 'false',
  },
];

const CriteriaBooleanField = ({
  fieldIdentifier = [],
  onChange = noop,
  error,
  value,
  disabled = false,
}) => {
  return (
    <BooleanPickerContainer isDisabled={disabled}>
      {Items.map((item) => {
        const id = `${fieldIdentifier.join('-')}-${item.label}`;
        const onClick = () => onChange(item.value, ...fieldIdentifier);
        return (
          <BooleanPicker key={id} showErrorState={error}>
            <Radio
              aria-labelledby={id}
              data-test="criteria-boolean-field-radio"
              isChecked={value === item.value}
              name={item.label}
              onClick={onClick}
              size={26}
              isDisabled={disabled}
            />
            <label onClick={onClick} id={id}>
              {item.label}
            </label>
          </BooleanPicker>
        );
      })}
    </BooleanPickerContainer>
  );
};

export default CriteriaBooleanField;
